export default __webpack_public_path__ + "static/media/piscina3.569b012d.jpg";